<template>
  <header class="header" :class="{darkBackground: heroDark, transparent}">
    <div class="nav-wrapper">
      <b-navbar toggleable="md" :class="{wideHeader}">
        <b-navbar-brand href="/" style="align-self: start;" @mousedown="startLongpress" @mouseup="stopLongpress"></b-navbar-brand>

        <b-navbar-nav class="ml-auto">
          <b-navbar-toggle is-nav target="header-nav">
            <i class="fa fa-bars fa-lg" color="black"></i>
          </b-navbar-toggle>
        </b-navbar-nav>

        <b-collapse is-nav id="header-nav">
          <div class="sidebar-overlay"></div>
          <b-navbar-toggle class="close" is-nav target="header-nav">
            <i class="fas fa-times fa-lg" />
          </b-navbar-toggle>
          <div class="header-nav mr-auto">
            <router-link class="header-nav-link header-nav-text-link" :class='{"is-active" : $route.path.match(/business-?cards|products/)}' to="/products">Business Cards</router-link>
            <router-link class="header-nav-link header-nav-text-link" :class='{"is-active" : $route.path.startsWith("/pricing")}' to="/pricing">Pricing</router-link>
            <router-link class="header-nav-link header-nav-text-link" :class='{"is-active" : $route.path.startsWith("/features")}' to="/features">Features</router-link>
            <router-link class="header-nav-link header-nav-text-link" :class='{"is-active" : $route.path.startsWith("/artworkguidelines")}' to="/artworkguidelines">Artwork</router-link>
          </div>

          <div class="header-nav ml-auto">
            <router-link class="header-nav-link" id="cart" to="/cart">
              <div class="cart-items">
                 <!-- <i class="fas fa-shopping-cart"></i> -->
                <svg class="dashboard-icons shopping-cart-icon"><use xlink:href="/static/images/dashboard/sprites.svg#cart"/></svg>
                 <div v-if="numCartItems" class="badge">{{numCartItems}}</div>
              </div>
            </router-link>


            <router-link v-if="showLogin" class="header-nav-link" :class='{"is-active" : $route.path==="/signin"}' to="/signin">Sign In</router-link>
            <a v-if="showLogin" class="header-nav-link" id="signup" href="/signup">Sign Up</a>
            <router-link v-if="showLoggedIn" class="header-nav-link" :class='{"is-active" : $route.path.startsWith("/dashboard")}' to="/dashboard">
              <svg class="dashboard-icons"><use xlink:href="/static/images/dashboard/sprites.svg#dashboard"/></svg>
            </router-link>
            <b-dropdown v-if="showLoggedIn" right no-caret :text="initials" variant="round" class="profile-menu ">
              <b-dropdown-header href="#">
                <div class="menu-fullname">{{userFullName}}</div>
                <div class="menu-auxname">{{username}}</div>
                <div class="menu-auxname">{{teamName}}<span class="admin-badge" v-if="isAdmin">admin</span></div>
              </b-dropdown-header>
              <b-dropdown-item href="/dashboard/settings/profile"><i class="fas fa-lg fa-cog icon"/> Edit Profile</b-dropdown-item>
              <b-dropdown-item v-if="isStaff"><router-link to="/admin/teams"><i class="fas fa-lg fa-sign-out-alt icon"/> Internal Dashboard</router-link></b-dropdown-item>
              <b-dropdown-item @click.prevent="onClickLogout" href="#"><i class="fas fa-lg fa-power-off icon"/> Log Out</b-dropdown-item>
              <template v-if="!isStaff && teamsToSwitch.length > 0">
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item-button disabled>Switch to</b-dropdown-item-button>
                <b-dropdown-item v-for="team in teamsToSwitch"
                                 :key="team.id"
                                 @click.prevent="enterTeam(team.id)"
                                 href="#"
                >
                  <i class="fas fa-lg fa-arrow-right icon" /> {{ team.name }}
                </b-dropdown-item>
              </template>
            </b-dropdown>
          </div>
        </b-collapse>
        <!-- end nav -->
      </b-navbar>
    </div>
    <b-modal ref="flagsModal" hide-footer title="Flags">
      <Flags/>
    </b-modal>
  </header>
</template>

<style lang="scss">
@import '~scss/colors';

// Apply some styles to the profile menu dropdown

.btn-round {
  display: block;
  height:32px;
  width: 32px;
  padding:.4em;
  font-size: 12px;
  line-height: 24px;
  letter-spacing:0px;
  background: $white;
  color:$black-0;
  border:$black-0 solid .5px;
  opacity:0.5;
  border-radius: 50% !important;
  margin-top:5px;

  &:hover {
    cursor: pointer;
    background: $black-0;
    color: $white;
  }
}

header.darkBackground.transparent .btn-round {
  color: white;
  border-color: white;
  background: rgba(255,255,255,0.25);
}

.profile-menu  {
  margin-left: 1em;
  height:40px;
  .menu-fullname {
    margin-bottom: 2px;
  }
  .menu-auxname {
    font-weight: normal;
    font-size: smaller;
    line-height: 1.5em;
  }
  .admin-badge {
    background-color: #ccc;
    color: white;
    padding: 0 4px;
    text-transform: uppercase;
    margin: 0 1em;
  }
  a.dropdown-item {
    padding: 1em 1.5em;
    line-height: 1.5em;
    svg.icon {
      color: #ccc;
      vertical-align: middle;
      margin-right: 0.5em;
    }
  }
}

</style>

<style lang="scss" scoped>
@import '~scss/colors.scss';

.nav-wrapper {
  transition: color 0.2s, background-color 0.6s;
}

header.darkBackground {
  background-color: $dark-blue;
  &.transparent .nav-wrapper {
    background-color: rgba(255,255,255,0);
    color: white;
    .dashboard-icons { fill: white; }
    a.header-nav-link { color: white; }
    .navbar-brand{ /* Brandly Logo */
      background: url(/static/images/logos/brandly/brandly-logo-light.svg) no-repeat center;
    }

  }
}

// Turn off animation of sidebar
.collapsing {
  transition: none !important;
}

.navbar {
  padding:0 !important;
  margin: 0 auto;
}

.btn, .header-nav-link,
.signin-account-submit,
.signup-account-submit  {
  display: inline-block;
  font-size: .95em;
  font-weight: 600;
  }

.header {
  width:100%;
  background: $white;
  z-index:10;
  height: 60px;
  }
nav {
  background: transparent;
  &.wideHeader {
    max-width:1300px;
  }
  max-width:1100px;
  height:100%;
  }
.nav-wrapper {
  position: fixed;
  padding: 0 40px;
  width: 100%;
  z-index: 10;
  height: 60px;
  background: rgba(255,255,255,1);
  // border-bottom: silver 1px solid;
  }
.navbar-brand{ /* Brandly Logo */
   background: url(/static/images/logos/brandly/brandly-logo-dark.svg) no-repeat center;
   width:120px;
   min-width: 120px;
   height:100%;
 }

 #cart{
   font-size:110%;
   cursor: pointer;
 }

 .cart-items{
   position:relative;
 }

 .badge{
  position:absolute;
  display:flex;
  justify-content:center;
  left:20px;
  bottom:15px;
  width:18px;
  height:18px;
  border-radius:50%;
  font-size:55%;
  font-weight:400;
  line-height:14px;
  color: white;
  background:$red;
}

.dashboard-icons{
  vertical-align: middle;
  width: 25px;
  height:25px;
  opacity:0.5;
&:hover{
  cursor: pointer;
  opacity:1;
  }
}


/* header mobile top */

.header-mobile-top {
  display: block;
  position: absolute;
  }

.header-nav-link {
  width: 100%;
  outline: none;
  }

a.header-nav-text-link {
  vertical-align: -3px;
  font-weight: normal;
}


#signin{
  border-left: solid 2px $black-0;
  padding-left:10px;
  }

.sidebar-overlay { display: none; }
.product-list{display:none;}

// Extra small devices (portrait phones, less than 576px)
@media only screen and (max-width: 767px) {
  #header-nav {
    position: fixed;
    z-index: 10;
    right: 0;
    width: 12em;
    top: 0;
    padding-top: 3em;
    bottom: 0;
    background: white;

    .sidebar-overlay {
      display: block;
      position: fixed;
      left: 0;
      background: rgba(0, 0, 0, 0.30);
      top: 0;
      right: 12em;
      bottom: 0;
    }
    .close {
      position: fixed;
      top: 1em;
      right: 1em;
    }
    .profile-menu {
      padding: 1em 0 0 0;
    }
    .header-nav-link {
      padding: 1em 0 0 20px;
      font-size: 1em;
    }
    .product-list{
      display:block;
    }
    .product-list li{
      list-style: none;
      margin-left: 1em;
    }
  }
  #signin{
    margin-top:14px;
    padding-left:0;
    border-left:none;
  }
}

// Medium devices and up
@media only screen and (min-width: 768px){
  .header-nav-link {
      display: inline-block;
      width: auto;
      margin: 0 0 0 .75em;
      text-align: left;
    }
  .header-nav{
     margin-top:0;
     height:100%;

  }
}

// When there's more room, let the menu items breathe
@media only screen and (min-width: 900px){
  .header-nav-link {
   margin: 0 0 0 .9em;
  }
}


</style>

<script>
import {mapGetters, mapActions} from 'vuex';
import Flags from "../pages/flags/Flags.vue";
import debounce from 'lodash/debounce';

export default {
  props: ['wideHeader', 'heroDark'],
  components: {Flags},
  data() {
    return {scrolled: false}
  },
  mounted() {
    this.getNumBasketLines();
    if (window.IntersectionObserver) {
      // Watch for any scroll
      let options = {
        rootMargin: '0px',
        threshold: 1.0
      }

      let callback = (events, observer) => {
        this.scrolled = events[0].intersectionRatio < 1;
      }
      let observer = new IntersectionObserver(callback, options);
      observer.observe(this.$el);
    } else {
      // Watch for any scroll, browsers without new API
      let scrollingElement = document.getElementById('app');
      this.fn = debounce(
        () => this.scrolled = (scrollingElement.scrollTop > 0),
        100,
        {leading: true}
      );
      scrollingElement.addEventListener('scroll', this.fn, {passive: true});
      this.unlisten = () => scrollingElement.removeEventListener('scroll', this.fn, {passive: true});
    }
  },
  beforeDestroy() {
    if (this.unlisten) this.unlisten();
  },
  computed: {
    ...mapGetters(['loggedIn', 'user', 'team', 'numBasketLines', 'isAdmin', 'isStaff', 'userTeams']),
    transparent() {
      return !this.scrolled;
    },
    initials() {
      // Ensure we don't crash without a user. This shouldnt happen though.
      if (!this.user) return '';
      return this.user.first_name.substring(0, 1) + this.user.last_name.substring(0, 1);
    },
    userFullName() {
      let {first_name, last_name} = this.user;
      return first_name + ' ' + last_name;
    },
    username() {
      return this.user.username;
    },
    teamName() {
      return this.team.name;
    },
    showLogin() {
      return !this.loggedIn;
    },
    showLoggedIn() {
      return this.loggedIn;
    },
    numCartItems() {
      // Return an empty string instead of 0
      return this.numBasketLines || '';
    },
    teamsToSwitch() {
      // Exclude current team because a user is already in it.
      return this.userTeams.filter((t) => t.id !== this.team.id);
    },
  },
  methods: {
    ...mapActions(['logout', 'getNumBasketLines', 'enterTeam']),
    startLongpress() {
      // Fired on mousedown
      if (this.longpressTimer) return;
      this.longpressTimer = setTimeout(this.onLongpress, 1000);
    },
    stopLongpress() {
      // mouseup, before timer goes off => cancel event
      if (!this.longpressTimer) return;
      clearTimeout(this.longpressTimer);
      this.longpressTimer = null;
    },
    onLongpress() {
      this.$refs.flagsModal.show();
      this.longpressTimer = null;
    },
    onClickLogout() {
      this.logout();
      this.$router.push('/signin');
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/Header.vue